import { Components } from '@mui/material';
import { Theme } from '@mui/material/styles';

import { elevationLevel } from '../constants';

export const accordionConfigs: Components<Theme>['MuiAccordion'] = {
  defaultProps: {
    elevation: elevationLevel.s,
  },
  styleOverrides: {
    root: ({ theme }) => ({
      borderRadius: 12,
      '::before': {
        display: 'none',
      },

      '.MuiAccordionSummary-root': {
        borderBottom: `1px solid transparent`,
        transition: theme.transitions.create('border-color'),
        padding: theme.spacing(2),
        margin: 0,
        minHeight: 0,

        '.MuiAccordionSummary-content': {
          margin: 0,
        },

        '&.Mui-expanded': {
          margin: 0,
          minHeight: 0,
          borderColor: theme.palette.grey[300],
        },
      },

      '.MuiAccordionDetails-root': {
        padding: theme.spacing(2),
      },

      '&.Mui-expanded': {
        margin: 0,
        minHeight: 0,
      },
    }),
  },
};
